import {
    all,
    call,
    fork,
    put,
    takeEvery
} from 'redux-saga/effects';
import {
    getProyecto,
    getDropboxFiles
} from "../../services/renders.dao";
import {
    INITIAL_PROYECTOS_WELCOME,
} from '../actions';

import {
    proyectosWelcome,
    loadingWelcome,
    ingresoWelcome,
    texturesWelcome
} from './actions';


/* const auth = {} */

const delay = time => new Promise(resolve => setTimeout(resolve, time));

export function* watchProyectosWelcome() {
    yield takeEvery(INITIAL_PROYECTOS_WELCOME, initialProyectosWelcomeSaga);
}


const proyectosWelcomeAsync = async () =>
    await getProyecto()
    .then(res => res)
    .catch(error => error);

const proyectosDropboxFilesWelcomeAsync = async () =>
    await getDropboxFiles()
    .then(res => res)
    .catch(error => error);


function* initialProyectosWelcomeSaga() {
    //LOADING MATERIAL
    const proyectos = yield call(proyectosWelcomeAsync);
    proyectos.data.menus = [{
        nombre: 'Vías de acceso',
        slug: 'ViasAcceso',
        ico: 'Vías',
        subMenu: []
    }, {
        nombre: 'Beneficios',
        slug: 'ZonasInteres',
        ico: 'ZonasDeInterés',
        subMenu: [
            {
                nombre: 'Salud',
                slug: 'salud-map',
                ico: 'Salud'
            }, 
            {
                nombre: 'Centros Comerciales',
                slug: 'comercio-map',
                ico: 'Comercio'
            }, 
            {
                nombre: 'Supermercados',
                slug: 'supermercados-map',
                ico: 'Supermercados'
            },
            {
                nombre: 'Instituciones Educativas',
                slug: 'educacion-map',
                ico: 'Educación'
            }
        ]
    }, {
        nombre: 'Amenidades',
        slug: 'Amenidades',
        ico: 'Amenidades',
        subMenu: []
    }, {
        nombre: 'Etapas',
        slug: 'Etapas',
        ico: 'Etapas',
        subMenu: []
    }, ]

    const dropboxFiles = yield call(proyectosDropboxFilesWelcomeAsync);
    console.log(dropboxFiles)
    var texts = dropboxFiles.data.files;
    var a = [];
    var dicc = {};

    texts.forEach((element) => {
        dicc[element.path] = element.link;
    });

    //yield put(loadingWelcome(true));
    
    yield put(texturesWelcome(dicc));
    yield put(proyectosWelcome(proyectos.data));
    //yield call(delay, 1500);
    //yield put(ingresoWelcome(true));
}



export default function* rootSaga() {
    yield all([
        fork(watchProyectosWelcome),
    ]);
}